/** Raw `##` section split for Initiative markdown documents. No ordering opinions. */
export const parseMarkdownSections = (markdown) => {
  const lines = String(markdown || '').split(/\r?\n/);
  const sections = [];
  const preamble = [];
  let title = null;
  let current = null;

  const flush = () => {
    if (!current) return;
    sections.push({
      title: current.title,
      body: current.body.join('\n').replace(/^\n+|\n+$/g, ''),
    });
  };

  for (const line of lines) {
    if (/^#\s+/.test(line)) {
      if (!title) title = line.replace(/^#\s+/, '').trim();
      continue;
    }
    const heading = line.match(/^##\s+(.+?)\s*$/);
    if (heading) {
      flush();
      current = { title: heading[1].trim(), body: [] };
      continue;
    }
    if (current) current.body.push(line);
    else if (line.trim()) preamble.push(line);
  }
  flush();

  return { title, preamble: preamble.join('\n').trim(), sections };
};

const sectionBodies = (markdown) =>
  new Map(
    parseMarkdownSections(markdown).sections.map((section) => [
      section.title.trim().toLowerCase(),
      { title: section.title, body: section.body.trim() },
    ])
  );

/** Section titles a revision added or rewrote, in the order they appear now. */
export const changedSectionTitles = (before, after) => {
  const previous = sectionBodies(before);
  const current = sectionBodies(after);
  const changed = [];
  current.forEach((section, key) => {
    const priorBody = previous.get(key)?.body;
    if (priorBody === undefined || priorBody !== section.body) changed.push(section.title);
  });
  return changed;
};

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;

/**
 * Collapses bare record IDs to a readable short code so notebook prose stays
 * scannable. IDs already inside code spans or URLs are left untouched.
 */
export const shortenRecordIds = (markdown) => {
  const text = String(markdown || '');
  if (!text) return text;
  return text.replace(UUID_RE, (match, offset) => {
    const before = text.slice(Math.max(0, offset - 1), offset);
    const after = text.slice(offset + match.length, offset + match.length + 1);
    if (before === '`' || after === '`') return match;
    if (before === '/' || before === '=' || before === '-') return match;
    return `\`${match.slice(0, 8)}\``;
  });
};
